module.exports = __webpack_public_path__ + "static/bela-vrtnica-70dd2f79b5a55b0b073b17afdb7ee536.jpg";